import { Section, Spinner } from '@ydistri/ds';
import { useGetProductSizesSkusQuery, useGetSingleProductQuery } from '../../../../apiDetail';
import React from 'react';
import DetailProductSizesTable from './DetailProductSizesTable';
import { NO_VALUE } from '../../../../../../lib/utils/utilsTypes';

interface DetailProductSizesTableProps {
  productId: number;
  storeId?: number;
}

const DetailProductSizes: React.FC<DetailProductSizesTableProps> = ({ productId, storeId }) => {
  const { data, isLoading } = useGetProductSizesSkusQuery({ productId, storeId });
  const { data: product } = useGetSingleProductQuery(productId);
  const isInvalidStoreId = storeId === undefined || storeId === NO_VALUE;

  let header = 'Sizes';
  if (product) {
    header = `${product.name} - Sizes`;
  }

  if (!isLoading && (data === undefined || data.length === 0)) {
    return null;
  }

  let body;
  if (isLoading) {
    body = <Spinner />;
  } else {
    // Show store columns only if storeId is NOT specified (if it is specified, only skus for that store are retrieved and then
    // all rows belong to the same store, and it would be redundant to show the store name for each row)
    // @ts-expect-error -- data is not undefined at this point
    body = <DetailProductSizesTable data={data} showStoreColumns={isInvalidStoreId} />;
  }
  return <Section header={header}>{body}</Section>;
};

export default DetailProductSizes;
